import {isObject, isEqual} from 'lodash'
import {OCSelectOptionType} from '../BasicOcComponents/OcAutocompleteSelect'
import {OcGenericDialogGroupProps, OcGenericDialogFieldType} from './OcGenericDialogInterfacesExport'
import {OcGenericDialogFieldBaseProps} from './OcGenericDialogInterfaces'
import {OcGenericDialogSingleFieldStateInput} from './OcGenericEditState'

export function getValueHelperFunction<SourceType>(
    group: string,
    field: string,
    data: SourceType[],
    dataGroups: {[key: string]: OcGenericDialogGroupProps<SourceType>}
) {
    let getValueFunction = dataGroups[group].fields[field].getValue
    if (data.length > 0) {
        if (!getValueFunction && isObject(data[0])) {
            getValueFunction = (data: SourceType) => {
                return data[field as keyof SourceType]
            }
        }

        if (getValueFunction) {
            let returnValue = getValueFunction(data[0])
            for (const item of data.slice(1)) {
                const value = getValueFunction(item)
                const combineFunc = (dataGroups[group].fields[field] as OcGenericDialogFieldBaseProps<SourceType, any>)
                    .combineItemsFunc

                switch (dataGroups[group].fields[field].type) {
                    case OcGenericDialogFieldType.Enum:
                        if ((returnValue as OCSelectOptionType)?.value !== (value as OCSelectOptionType)?.value) {
                            return undefined
                        }
                        break
                    case OcGenericDialogFieldType.Custom:
                        if (!combineFunc && !isEqual(returnValue, value)) {
                            return undefined
                        } else if (combineFunc) {
                            const combinedValue = combineFunc(returnValue, value)
                            if (typeof combinedValue === 'undefined') {
                                return undefined
                            } else {
                                returnValue = combinedValue
                            }
                        }
                        break
                    default:
                        if (returnValue !== value) {
                            return undefined
                        }
                }
            }

            return returnValue
        }
    }
    return undefined
}

export function getDialogStateInputFields<SourceType>(
    dataGroups: {
        [key: string]: OcGenericDialogGroupProps<SourceType>
    },
    getValueCallback: (group: string, field: string) => any
): OcGenericDialogSingleFieldStateInput<SourceType>[] {
    const fieldInputs: OcGenericDialogSingleFieldStateInput<SourceType, any>[] = []
    Object.entries(dataGroups).forEach(([groupName, grouProps]) => {
        Object.entries(grouProps.fields).forEach(([fieldName, fieldProps]) => {
            fieldInputs.push({
                fieldName: fieldName,
                groupName: groupName,
                setValueFunction: fieldProps.setValue,
                validateFunction: (fieldProps as OcGenericDialogFieldBaseProps<SourceType, any>).validateValue,
                mandatory: typeof fieldProps.mandatory !== 'undefined' ? fieldProps.mandatory : false,
                initialValue: getValueCallback(groupName, fieldName),
                defaultValue: fieldProps.defaultValue,
                displayCondition: fieldProps.displayCondition,
                mandatoryErrorText: (fieldProps as OcGenericDialogFieldBaseProps<SourceType, any>).mandatoryErrorText
            })
        })
    })
    return fieldInputs
}
